module.exports = __webpack_public_path__ + "static/img/ptas-logo.2150271d.png";